"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const User = __importStar(require("../../../../user"));
const openapi_1 = require("../../../openapi");
const Asset = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Asset.Spec';
const Role = User.GlobalUserRole.enums;
const UrlResponse = openapi_1.Response.Success(Asset.UrlData).annotations({
    description: 'Signed upload URL or public view URL for a static asset',
});
const getUploadUrl = platform_1.HttpApiEndpoint.get('getAssetUploadUrl') `/upload-url`
    .setUrlParams(Asset.UploadUrlQuery)
    .addSuccess(UrlResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Get Asset Upload URL')
    .annotate(platform_1.OpenApi.Description, 'Returns a signed URL, valid for 12 hours, for uploading a public static asset. ' +
    'Upload the file with HTTP PUT to that URL, using Content-Type: application/octet-stream ' +
    'and x-ms-blob-type: BlockBlob.')
    .pipe(openapi_1.Security.v1Roles(Role.SystemAdmin, Role.Admin, Role.BrandManager), openapi_1.Error.withV1StandardErrors);
const getViewUrl = platform_1.HttpApiEndpoint.get('getAssetViewUrl') `/url`
    .setUrlParams(Asset.ViewUrlQuery)
    .addSuccess(UrlResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Get Public Asset URL')
    .annotate(platform_1.OpenApi.Description, 'Returns a public URL for viewing a static asset via HTTP GET.')
    .pipe(openapi_1.Security.v1Roles(Role.SystemAdmin, Role.Admin, Role.BrandManager, Role.BrandSupportOperator, Role.BrandTechOperator, Role.Dealer, Role.DealerTechnician), openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.admin.asset')
    .add(getUploadUrl)
    .add(getViewUrl)
    .prefix('/admin/asset')
    .annotate(platform_1.OpenApi.Title, 'Assets')
    .annotate(platform_1.OpenApi.Description, 'Static asset URL endpoints')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
//# sourceMappingURL=spec.js.map